/**
 * When "Skip quick view drawer" is on:
 * - Color swatch click: set active state only (no navigate); optional media update.
 * - Size option click: add to cart with variant (selected color + selected size), open cart drawer.
 */
(function () {
  if (typeof window.routes === 'undefined' || !window.routes.cart_add_url) return;

  function injectSizeOptionsStylesIntoShadowRoot(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector('link[href*="product-card-size-options"]')) return;
    var docLink = document.querySelector('link[href*="product-card-size-options"]');
    if (!docLink || !docLink.href) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = docLink.href;
    shadowRoot.appendChild(link);
  }

  function injectStylesIntoProductCards() {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.shadowRoot && !card.shadowRoot.querySelector('link[href*="product-card-size-options"]')) {
        injectSizeOptionsStylesIntoShadowRoot(card.shadowRoot);
      }
    }
  }

  function getMobileSizeDrawerPortal() {
    return document.getElementById('ProductCardMobileSizeDrawer');
  }

  function getCard(el) {
    if (!el) return null;
    var portal = getMobileSizeDrawerPortal();
    if (portal && el.closest && el.closest('#ProductCardMobileSizeDrawer')) {
      if (portal._sourceProductCard) return portal._sourceProductCard;
      return null;
    }
    var root = el.getRootNode && el.getRootNode();
    if (root && root.host) return root.host;
    return el.closest('product-card') || el.closest('.product-card');
  }

  function getSizeOptionsContainer(card) {
    if (!card) return null;
    var r = card.shadowRoot || card;
    var c = r.querySelector('.product-card__size-options');
    if (c) return c;
    var portal = getMobileSizeDrawerPortal();
    if (portal && portal._sourceProductCard === card) {
      c = portal.querySelector('.product-card__size-options');
      if (c) return c;
    }
    return null;
  }

  function hasSizeBar(card) {
    return getSizeOptionsContainer(card) !== null;
  }

  function getVariantsForCard(card) {
    var root = card.shadowRoot || card;
    var script = root.querySelector && root.querySelector('script[data-product-card-variants]');
    if (!script || !script.textContent) return [];
    try {
      return JSON.parse(script.textContent.trim());
    } catch (_) {
      return [];
    }
  }

  /**
   * Get the selected color value for variant lookup (option1).
   * Works with both image-swatches and shape-swatches: find any [data-color-swatches-item][data-variant-id].is-active,
   * then resolve option1 from variants[] so it matches JSON exactly.
   */
  function getSelectedColor(card, variants) {
    if (isMetafieldRelatedColorsCard(card)) return '';
    var root = card.shadowRoot || card;
    var selector = '[data-color-swatches-item][data-variant-id]:not([data-color-swatches-hidden-count])';
    var active = root.querySelector(selector + '.is-active');
    if (!active) {
      var first = root.querySelector(selector);
      active = first;
    }
    if (active && variants && variants.length) {
      var variantIdAttr = active.getAttribute('data-variant-id');
      if (variantIdAttr) {
        var vid = parseInt(variantIdAttr, 10);
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === vid) return (variants[i].option1 != null ? String(variants[i].option1).trim() : '');
        }
      }
    }
    return active ? (active.getAttribute('data-color') || '').trim() : '';
  }

  function findVariantId(variants, option1, option2) {
    option1 = (option1 || '').trim().toLowerCase();
    option2 = (option2 || '').trim().toLowerCase();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var o1 = (v.option1 || '').trim().toLowerCase();
      var o2 = (v.option2 || '').trim().toLowerCase();
      if (o1 === option1 && o2 === option2) return v.id;
    }
    if (!option1 && option2) {
      for (var j = 0; j < variants.length; j++) {
        var w = variants[j];
        if ((w.option2 || '').trim().toLowerCase() === option2) return w.id;
        if ((w.option1 || '').trim().toLowerCase() === option2) return w.id;
      }
    }
    return null;
  }

  function isMetafieldRelatedColorsCard(card) {
    var root = card.shadowRoot || card;
    return root.querySelector('[data-product-card-metafield-related-colors]') !== null;
  }

  function getRelatedColorVariantsMap(card) {
    var root = card.shadowRoot || card;
    var s = root.querySelector('script[data-product-card-related-color-variants-map]');
    if (!s || !s.textContent) return null;
    try {
      return JSON.parse(s.textContent.trim());
    } catch (_) {
      return null;
    }
  }

  function getSizeOptionIndex(card) {
    var container = getSizeOptionsContainer(card);
    if (!container) return 1;
    var idx = parseInt(container.getAttribute('data-size-option-index') || '1', 10);
    if (isNaN(idx) || idx < 0 || idx > 2) return 1;
    return idx;
  }

  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function rebuildSizeBarFromVariants(card, variants, sizeOptionIndex, productId) {
    var container = getSizeOptionsContainer(card);
    if (!container || !variants || !variants.length) return;
    var root = card.shadowRoot || card;
    var key = sizeOptionIndex === 0 ? 'option1' : sizeOptionIndex === 1 ? 'option2' : 'option3';
    var seen = {};
    var order = [];
    for (var i = 0; i < variants.length; i++) {
      var val = (variants[i][key] || '').trim();
      if (!val || seen[val]) continue;
      seen[val] = true;
      order.push(val);
    }
    var addLabel = 'Add to cart';
    var soldLabel = 'Sold out';
    var btnText = root.querySelector('[data-product-card-button-text], [data-button-text]');
    if (btnText && btnText.textContent) addLabel = btnText.textContent.trim();

    var html = '';
    var pid = productId != null ? String(productId) : container.getAttribute('data-product-id') || 'p';
    for (var j = 0; j < order.length; j++) {
      var value = order[j];
      var sizeVariant = null;
      for (var k = 0; k < variants.length; k++) {
        if ((variants[k][key] || '').trim() === value) {
          sizeVariant = variants[k];
          break;
        }
      }
      if (!sizeVariant) continue;
      var avail = sizeVariant.available !== false;
      var vid = sizeVariant.id;
      var handle = String(value)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'x';
      var inputId = 'product-card-size-' + handle + '-' + pid;
      html +=
        '<input type="radio" name="product-card-size-' +
        escapeAttr(pid) +
        '" class="hidden product-card__size-input' +
        (avail ? '' : ' disabled') +
        '" value="' +
        escapeAttr(value) +
        '" id="' +
        escapeAttr(inputId) +
        '" data-variant-id="' +
        vid +
        '" data-product-id="' +
        escapeAttr(pid) +
        '" data-status="' +
        (avail ? 'InStock' : 'OutOfStock') +
        '" data-status-text="' +
        escapeAttr(avail ? addLabel : soldLabel) +
        '"' +
        (avail ? '' : ' disabled') +
        '>';
      html +=
        '<label for="' +
        escapeAttr(inputId) +
        '" class="product-card__size-label text-body-sm">' +
        escapeAttr(value) +
        '</label>';
    }
    container.setAttribute('data-product-id', pid);
    container.setAttribute('data-size-count', String(order.length));
    container.style.setProperty('--size-count', String(order.length));
    container.innerHTML = html;
  }

  function syncRelatedProductOnSwatch(card, swatchLink) {
    if (!swatchLink || !swatchLink.hasAttribute('data-related-product-id')) return;
    var pid = swatchLink.getAttribute('data-related-product-id');
    var map = getRelatedColorVariantsMap(card);
    if (!map) return;
    var list = map[pid];
    if (!list || !list.length) list = map[String(pid)];
    if (!list || !list.length) return;
    var root = card.shadowRoot || card;
    var script = root.querySelector('script[data-product-card-variants]');
    if (script) {
      script.textContent = JSON.stringify(list);
      script.setAttribute('data-product-id', String(pid));
    }
    rebuildSizeBarFromVariants(card, list, getSizeOptionIndex(card), pid);
    if (typeof window.applyProductCardMetafieldSwatchInfo === 'function') {
      window.applyProductCardMetafieldSwatchInfo(card, swatchLink);
    }
    var gAttr = swatchLink.getAttribute('data-variant-gallery');
    var galleryUrls =
      typeof window.parseProductCardGalleryAttr === 'function'
        ? window.parseProductCardGalleryAttr(gAttr)
        : [];
    if (galleryUrls.length && typeof window.updateProductCardGallery === 'function') {
      window.updateProductCardGallery(card, galleryUrls);
    }
    try {
      card.dispatchEvent(
        new CustomEvent('product-card-swatch-active', {
          bubbles: true,
          detail: {
            activeLink: swatchLink,
            variantId: swatchLink.getAttribute('data-variant-id'),
          },
        })
      );
    } catch (_) {}
  }

  /**
   * Open the cart drawer the same way the PDP does:
   * 1) Update drawer content from add-response section HTML (updateAsideProductsByParsedState, updateEmptyStatus, purchaseHandler).
   * 2) Call drawer.show() and sync [data-sidebar-id="CartDrawer"] buttons with is-opened.
   * 3) If drawer still not open, programmatically click the cart icon so the theme's SidebarButton handler runs (sidebar.toggle).
   */
  function openCartDrawer(parsedState) {
    try {
      var drawer = document.querySelector('#CartDrawer');
      if (!drawer) return;

      var sectionId = drawer.getAttribute('data-section-id');
      var sectionHtml = parsedState && parsedState.sections && sectionId ? parsedState.sections[sectionId] : null;
      var parsedNode = null;
      if (typeof sectionHtml === 'string') {
        try {
          parsedNode = new DOMParser().parseFromString(sectionHtml, 'text/html');
        } catch (_) {}
      }

      if (sectionHtml && typeof drawer.updateAsideProductsByParsedState === 'function') {
        try {
          drawer.updateAsideProductsByParsedState(parsedState);
        } catch (_) {}
      }
      if (typeof drawer.updateEmptyStatus === 'function') {
        try {
          drawer.updateEmptyStatus();
        } catch (_) {}
      }
      if (parsedNode && typeof drawer.purchaseHandler === 'function') {
        try {
          drawer.purchaseHandler(parsedNode, parsedState);
        } catch (_) {}
      }
      if (parsedNode && !drawer.querySelector('[data-sidebar-body]') || (drawer.querySelector('[data-cart-drawer-results]') && !drawer.querySelector('[data-cart-drawer-results]').children.length)) {
        var newBody = parsedNode.querySelector && parsedNode.querySelector('[data-sidebar-body]');
        var currentBody = drawer.querySelector('[data-sidebar-body]');
        if (newBody && currentBody && newBody.innerHTML) {
          try {
            currentBody.replaceChildren.apply(currentBody, [].slice.call(newBody.cloneNode(true).childNodes));
          } catch (_) {}
        }
      }

      if (typeof drawer.show === 'function') {
        try {
          drawer.show();
        } catch (_) {}
      }
      setTimeout(function () {
        try {
          if (!drawer.classList.contains('is-opened')) {
            drawer.classList.add('is-opened');
            var buttons = document.querySelectorAll('[data-sidebar-id="CartDrawer"]');
            for (var i = 0; i < buttons.length; i++) buttons[i].classList.add('is-opened');
            var btn = document.querySelector('[data-sidebar-id="CartDrawer"]');
            if (btn) {
              var trigger = (btn.querySelector && btn.querySelector('[data-sidebar-button]')) || btn;
              if (trigger && trigger.click) trigger.click();
            }
          }
        } catch (_) {}
      }, 50);
    } catch (_) {}
  }

  function notifyCartUpdated() {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (_) {}
  }

  function addToCartFromCard(variantId, card, sizeLabel) {
    var drawer = document.querySelector('#CartDrawer');
    var sectionId = drawer && drawer.getAttribute('data-section-id');
    var url = window.routes.cart_add_url || '';
    if (url && url.indexOf('.js') === -1) {
      var q = url.indexOf('?');
      url = (q >= 0 ? url.slice(0, q) : url) + '.js' + (q >= 0 ? url.slice(q) : '');
    }

    var form = new FormData();
    form.append('id', variantId);
    form.append('quantity', 1);
    if (sectionId) form.append('sections', sectionId);

    return fetch(url, {
      method: 'POST',
      body: form,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.text().then(function (text) {
          try {
            return { ok: r.ok, data: JSON.parse(text), status: r.status };
          } catch (_) {
            return { ok: r.ok, data: null, status: r.status };
          }
        });
      })
      .then(function (result) {
        var data = result.data;
        if (data && data.description) {
          if (typeof data.description === 'object' && data.message) {
            return Promise.reject(new Error(data.message));
          }
          if (typeof data.description === 'string') {
            return Promise.reject(new Error(data.description));
          }
        }
        notifyCartUpdated();
        try {
          openCartDrawer(data);
        } catch (_) {}
        try {
          document.dispatchEvent(
            new CustomEvent('product-card-quick-add-added', {
              bubbles: true,
              detail: { card: card },
            })
          );
        } catch (_) {}
        return data;
      });
  }

  function getClickedSwatchLink(e) {
    var path = e.composedPath && e.composedPath();
    if (path && path.length) {
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (
          el &&
          el.nodeType === 1 &&
          el.hasAttribute &&
          el.hasAttribute('data-color-swatches-item') &&
          el.hasAttribute('data-variant-id')
        )
          return el;
      }
    }
    return e.target && e.target.closest ? e.target.closest('a[data-color-swatches-item][data-variant-id]') : null;
  }

  document.addEventListener('click', function (e) {
    var swatchLink = getClickedSwatchLink(e);
    if (swatchLink && swatchLink.hasAttribute('data-color-swatches-hidden-count')) return;

    if (swatchLink) {
      var swatchRoot = swatchLink.closest('[data-product-card-color-swatches]');
      var clickBehavior = swatchRoot ? swatchRoot.getAttribute('data-color-swatches-click-behavior') : '';
      if (clickBehavior === 'navigate') {
        return;
      }
      var card = getCard(swatchLink);
      if (card && hasSizeBar(card)) {
        e.preventDefault();
        e.stopPropagation();
        var root = card.shadowRoot || card;
        var clickedVariantId = swatchLink.getAttribute('data-variant-id');
        var allSwatches = root.querySelectorAll('[data-color-swatches-item][data-variant-id]:not([data-color-swatches-hidden-count])');
        for (var i = 0; i < allSwatches.length; i++) {
          allSwatches[i].classList.remove('is-active');
          if (allSwatches[i].getAttribute('data-variant-id') === clickedVariantId) {
            allSwatches[i].classList.add('is-active');
          }
        }
        syncRelatedProductOnSwatch(card, swatchLink);
        if (typeof console !== 'undefined' && console.log) {
          console.log('[product-card-quick-add] Color swatch selected → variant id:', clickedVariantId);
        }
      }
      return;
    }

    var sizeLabel = e.target.closest('.product-card__size-label');
    if (!sizeLabel) return;

    var sizeInput = sizeLabel.control || document.getElementById(sizeLabel.getAttribute('for'));
    if (!sizeInput || !sizeInput.classList.contains('product-card__size-input')) return;
    if (sizeInput.disabled || sizeInput.classList.contains('disabled')) {
      e.preventDefault();
      return;
    }

    var card = getCard(sizeLabel);
    if (!card || !hasSizeBar(card)) return;

    e.preventDefault();

    var variants = getVariantsForCard(card);
    var selectedColor = getSelectedColor(card, variants);
    var selectedSize = (sizeInput.value || '').trim();
    var variantId = null;
    if (variants.length) {
      variantId = findVariantId(variants, selectedColor, selectedSize);
      if (!variantId) variantId = findVariantId(variants, selectedSize, selectedColor);
    }
    if (!variantId) variantId = sizeInput.getAttribute('data-variant-id');

    if (!variantId) return;

    if (typeof console !== 'undefined' && console.log) {
      console.log('[product-card-quick-add] Add to cart → color:', selectedColor, 'size:', selectedSize, 'variantId:', variantId);
    }
    addToCartFromCard(variantId, card, sizeLabel).catch(function (err) {
      if (window.auroraThemeLocales && window.auroraThemeLocales.cartStrings && window.auroraThemeLocales.cartStrings.error) {
        console.warn('Quick add to cart failed:', err);
      }
    });
  }, true);

  /* Hover class on size labels so hover effect works (e.g. inside shadow DOM) */
  document.addEventListener('mouseover', function (e) {
    var label = e.target.closest && e.target.closest('.product-card__size-label');
    if (!label) return;
    var input = label.control || (label.getAttribute('for') && document.getElementById(label.getAttribute('for')));
    if (input && (input.disabled || input.classList.contains('disabled'))) return;
    var container = label.closest('.product-card__size-options');
    if (container) {
      container.querySelectorAll('.product-card__size-label--hover').forEach(function (l) {
        l.classList.remove('product-card__size-label--hover');
      });
    }
    label.classList.add('product-card__size-label--hover');
  }, true);
  document.addEventListener('mouseout', function (e) {
    var label = e.target.closest && e.target.closest('.product-card__size-label');
    if (label) label.classList.remove('product-card__size-label--hover');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectStylesIntoProductCards();
      setTimeout(injectStylesIntoProductCards, 100);
    });
  } else {
    injectStylesIntoProductCards();
    setTimeout(injectStylesIntoProductCards, 100);
  }
})();
